"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopDataType = void 0;
var PopDataType;
(function (PopDataType) {
    PopDataType["CategoryTemplate"] = "POP_DATA_TYPE_CATEGORY_TEMPLATE";
    PopDataType["SubjectTemplate"] = "POP_DATA_TYPE_SUBJECT_TEMPLATE";
    PopDataType["GroupTemplate"] = "POP_DATA_TYPE_GROUP_TEMPLATE";
    PopDataType["LevelTemplate"] = "POP_DATA_TYPE_LEVEL_TEMPLATE";
    PopDataType["ModuleTemplate"] = "POP_DATA_TYPE_MODULE_TEMPLATE";
    PopDataType["CardTemplate"] = "POP_DATA_TYPE_CARD_TEMPLATE";
    PopDataType["ConceptTemplate"] = "POP_DATA_TYPE_CONCEPT_TEMPLATE";
})(PopDataType = exports.PopDataType || (exports.PopDataType = {}));
